import { ErrorMessageCount } from '@Generated/back-office-client/src'
import { Heading, Skeleton, Table, Text, Tooltip } from '@radix-ui/themes'
import { formatInTimeZone } from 'date-fns-tz'

const NO_MESSAGE = '(no message)'

export const ErrorMessagesTable = ({
  errorMessages,
  timezone,
  loading,
}: {
  errorMessages: ErrorMessageCount[]
  timezone: string
  loading: boolean
}) => {
  return (
    <>
      <Heading size="4">Errors</Heading>
      {errorMessages.length ? (
        <Table.Root>
          <Table.Header>
            <Table.Row>
              <Table.ColumnHeaderCell>Message</Table.ColumnHeaderCell>
              <Table.ColumnHeaderCell>Count</Table.ColumnHeaderCell>
              <Table.ColumnHeaderCell>Last seen</Table.ColumnHeaderCell>
            </Table.Row>
          </Table.Header>
          <Table.Body>
            {errorMessages.map((errorMessage) => {
              const message = errorMessage.message ?? NO_MESSAGE
              return (
                <Table.Row key={message}>
                  <Table.Cell maxWidth="600px">
                    <Tooltip content={message}>
                      <Text truncate as="div">
                        {message}
                      </Text>
                    </Tooltip>
                  </Table.Cell>
                  <Table.Cell>{errorMessage.count}</Table.Cell>
                  <Table.Cell>
                    {formatInTimeZone(errorMessage.lastSeenAt, timezone, 'PP p')}
                  </Table.Cell>
                </Table.Row>
              )
            })}
          </Table.Body>
        </Table.Root>
      ) : (
        <Skeleton loading={loading}>
          <Text>No errors in this window</Text>
        </Skeleton>
      )}
    </>
  )
}
